import React, {useState, useEffect} from 'react';
import YourCompanies from './YourCompanies';
import CompaniesInner from './CompaniesInner/CompaniesInner';

import {ReactComponent as MenuIcon} from '../../assets/icons/menu.svg';
import {ReactComponent as ContentIcon} from '../../assets/icons/content.svg';
import './Companies.scss';
import {mainPath} from '../../routes/paths';
import {Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {hasPermission} from "../../helpers/functions";
import {PERMISSIONS} from "../../helpers/constants";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const Companies = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [isMenuVisible, setMenuVisible] = useState(false);
    const [isYourContentVisible, setYourContentVisible] = useState(true);
    const [isInnerVisible, setInnerVisible] = useState(true);
    const {profileMe} = useSelector((state) => state.profile);
    const permissionCompany = hasPermission(PERMISSIONS.COMPANY_READ, profileMe?.permissions ?? []);

    const handleCompanySelect = () => {
        if (window.innerWidth >= 1690) {
            setMenuVisible(true);
            setInnerVisible(true);
            setYourContentVisible(true);
        }

        if (window.innerWidth < 1690) {
            setMenuVisible(true);
            setInnerVisible(true);
            setYourContentVisible(false);
        }

        if (window.innerWidth < 1080) {
            setYourContentVisible(false);
            setInnerVisible(false);
            setMenuVisible(true);
        }
    };

    const handleNavLinkClick = () => {
        if (window.innerWidth < 1080) {
            setYourContentVisible(false);
            setInnerVisible(true);
            setMenuVisible(false);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            const pathSegments = location.pathname.split('/').filter(Boolean);
            const isProjectPage = pathSegments.length > 2 && pathSegments.length <= 3;
            const isInnerPage = pathSegments.length > 3;
            const isNarrowScreen = window.innerWidth < 1080;
            const isWidderScreen = window.innerWidth > 1080 && window.innerWidth < 1690;

            if (isProjectPage) {
                setMenuVisible(true);
                setInnerVisible(!isNarrowScreen);
                setYourContentVisible(!isNarrowScreen && !isWidderScreen);
            } else if (isInnerPage) {
                setMenuVisible(!isNarrowScreen);
                setInnerVisible(true);
                setYourContentVisible(!isNarrowScreen && !isWidderScreen);
            } else {
                setMenuVisible(false);
                setInnerVisible(false);
                setYourContentVisible(true);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [location]);

    useEffect(() => {
        if (profileMe?.id && !permissionCompany) {
            history.push('/')
        }
    }, [profileMe]);

    const toggleMenu = () => {
        setMenuVisible(true);
        setYourContentVisible(false);
        setInnerVisible(false);
    };

    const toggleYourContent = () => {
        history.push(mainPath.companies);
        setYourContentVisible(true);
        setMenuVisible(false);
        setInnerVisible(false);
    };

    return (
        <div className='page companies-page'>
            {!isMenuVisible && !isYourContentVisible && (
                <div className='hidden-menu'>
                    <div className='hidden-menu__content' onClick={toggleYourContent}>
                        <ContentIcon/>
                        Компанії
                    </div>
                    <div className='hidden-menu__menu' onClick={toggleMenu}>
                        <MenuIcon/>
                        {t('profile.menu')}
                    </div>
                </div>
            )}

            {isYourContentVisible && <YourCompanies onCompanySelect={handleCompanySelect}/>}
            <Switch>
                <Route
                    path={mainPath.company}
                    render={(props) => (
                        <CompaniesInner
                            {...props}
                            handleNavLinkClick={handleNavLinkClick}
                            toggleYourContent={toggleYourContent}
                            isYourContentVisible={isYourContentVisible}
                            isMenuVisible={isMenuVisible}
                            isInnerVisible={isInnerVisible}
                        />
                    )}
                />
            </Switch>
        </div>
    );
};

export default Companies;
